import { useOperationStore } from '@/features/operation/stores/OperationStore'

export function blockLoadingGuard(to, from, next) {
  const operationStore = useOperationStore()
  if (operationStore.loading) {
    // Cancel navigation while an operation key request is in progress
    return next(false)
  }
  next()
}
